import { pipeLatLngs, pathLength } from './model';
import { getCatalog, itemLabel } from './catalog';

// net material list: fittings (pcs) + pipes (lfm) linked to catalogue items
// plan = true -> planned (offer) quantities, else executed (billing) quantities
export function materialRows(project, reportId = null, plan = false) {
  const ov = project.prices?.items || {};
  const items = Object.fromEntries(getCatalog().items.map((x) => [x.id, { ...x, price: ov[x.id]?.price ?? x.price, install: ov[x.id]?.install ?? x.install }]));
  const fittings = project.fittings || [];
  const groups = {};
  const add = (src, qty) => {
    const pr = src.prod;
    const it = pr ? { name: `${pr.name} (${pr.mfr})`, dim: pr.dim, sku: pr.sku, unit: items[src.catId]?.unit || src.cat?.unit || 'pcs', price: pr.price, install: items[src.catId]?.install ?? null } : items[src.catId] || src.cat || null;
    if (!it) return;
    const dim = src.dn ? `DN ${src.dn}` : it.dim || '';
    const key = `${pr ? `p:${pr.mfrId}:${pr.ref}` : src.catId}|${dim}`;
    const g = groups[key] || (groups[key] = { key, type: src.type || it.type || '', name: it.name, dim, sku: it.sku || '', unit: it.unit, qty: 0, price: it.price, install: it.install });
    g.qty += qty;
  };
  fittings.filter((f) => (!reportId || f.reportId === reportId) && !!f.plan === plan).forEach((f) => add(f, 1));
  (project.pipes || []).filter((p) => (!reportId || p.reportId === reportId) && !!p.plan === plan).forEach((p) => add(p, pathLength(pipeLatLngs(p, fittings))));
  (plan ? [] : project.facades || []).filter((z) => z.out && (!reportId || z.repId === reportId)).forEach((z) => {
    const r = z.out, use = { paint: z.usePaint !== false, wdvs: !!z.useWdvs, scaf: z.useScaf !== false };
    [[use.paint, [['b01', r.paint], ['b02', r.primer]]], [use.wdvs, [['b04', r.wdvs], ['b06', r.glue], ['b07', r.mesh], ['b08', r.dowels]]], [use.scaf, [['b09', r.sA], ['b10', r.anchors], ['b11', r.jacks], ['b12', r.net]]]]
      .forEach(([on, list]) => on && list.forEach(([catId, q]) => q > 0 && add({ catId }, q)));
  });
  // free / manufacturer positions entered directly in the report
  (plan ? [] : project.reports || []).filter((r) => !reportId || r.id === reportId).forEach((r) => (r.materials || []).forEach((m) => {
    if (!(+m.qty > 0) || !m.name) return;
    add({ catId: `rm:${m.mfrId || ''}:${m.ref || m.id}:${m.price ?? ''}:${m.dealer || ''}`, cat: { name: `${m.mfr ? `${m.name} (${m.mfr})` : m.name}${m.dealerName ? ` – ${m.dealerName}` : ''}`, dim: m.dim || '', sku: m.sku || '', unit: m.unit || 'pcs', price: m.price ?? null, install: null } }, +m.qty);
  }));
  const rows = Object.values(groups).map((g) => {
    const unitCost = (g.price != null ? +g.price : 0) + (g.install != null ? +g.install : 0);
    return { ...g, label: itemLabel({ name: g.name, dim: g.dim }), amount: g.price != null || g.install != null ? unitCost * g.qty : null };
  });
  return { rows, total: rows.reduce((s, r) => s + (r.amount || 0), 0) };
}

export const fmtQty = (r, locale) => (r.unit === 'lfm' ? r.qty.toLocaleString(locale, { minimumFractionDigits: 1, maximumFractionDigits: 1 }) : String(Math.round(r.qty * 100) / 100));
